<template>
    <div class="hotel-order-list">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">酒店订单列表</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button type="primary" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
                    </el-col>
                    <el-col>
                        <el-input size="small" placeholder="按订单号搜索" v-model="filters.order_no" style="width:200px"
                            clearable @clear="fetchData" @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                        <el-input size="small" placeholder="按联系人姓名搜索" v-model="filters.contact_name"
                            style="width:200px; margin-left:8px" clearable @clear="fetchData"
                            @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                    </el-col>
                </el-row>

                <el-table :data="pageData" stripe border style="width: 100%; margin-top: 12px" row-key="id"
                    :loading="loading">
                    <el-table-column prop="id" label="ID" width="120" align="center" header-align="center" />
                    <el-table-column prop="order_no" label="订单号" width="300" align="center" header-align="center" />
                    <el-table-column prop="amount" label="订单金额" width="120" align="right" header-align="center" />
                    <el-table-column prop="contact_name" label="联系人名" width="120" align="center"
                        header-align="center" />
                    <el-table-column prop="contact_mobile" label="联系人手机号" width="140" align="center"
                        header-align="center" />
                    <el-table-column prop="order_status" label="订单状态" width="140" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="getStatusTagType(row.order_status)">{{
                                formatStatus(row.order_status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="下单时间" align="center" header-align="center" />
                    <el-table-column prop="check_in_date" label="入住时间" align="center" header-align="center" />
                    <el-table-column prop="check_out_date" label="退房时间" align="center" header-align="center" />
                    <!-- <el-table-column label="操作" fixed="right" width="150" align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleDetails(scope.row)">详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 订单详情对话框 -->
        <el-dialog :visible.sync="detailDialog" title="订单详情" width="600px" :close-on-click-modal="false">
            <div v-if="detailData">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
                    <el-descriptions-item label="订单号">{{ detailData.order_no }}</el-descriptions-item>
                    <el-descriptions-item label="订单金额">{{ detailData.amount }}</el-descriptions-item>
                    <el-descriptions-item label="联系人名">{{ detailData.contact_name }}</el-descriptions-item>
                    <el-descriptions-item label="联系人手机号">{{ detailData.contact_mobile }}</el-descriptions-item>
                    <el-descriptions-item label="订单状态">{{ formatStatus(detailData.order_status)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="下单时间">{{ detailData.create_time }}</el-descriptions-item>
                    <el-descriptions-item label="入住时间">{{ detailData.check_in_date }}</el-descriptions-item>
                    <el-descriptions-item label="退房时间">{{ detailData.check_out_date }}</el-descriptions-item>
                    <!-- 根据实际数据结构调整其他字段 -->
                    <el-descriptions-item label="酒店名称">{{ detailData.hotel_name || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="房型">{{ detailData.room_type || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="备注">{{ detailData.remark || '-' }}</el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { hotelOrderList } from '@/api/api'

export default {
    name: 'HotelOrderList',
    data() {
        return {
            loading: false,
            list: [],
            total: 0,
            pager: { page: 1, pageSize: 15 },
            filters: { order_no: '', contact_name: '' },
            detailDialog: false,
            detailData: null
        }
    },
    computed: {
        pageData() {
            // 服务端已处理分页，直接返回list
            return this.list
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    order_no: this.filters.order_no || undefined,
                    contact_name: this.filters.contact_name || undefined
                }
                const res = await hotelOrderList(params)

                this.list = res.data.data || []
                this.total = res.data.total || 0
            } catch (err) {
                console.error('hotelOrderList error', err)
                this.$message.error(err.message || '获取酒店订单列表失败')
                // 提供模拟数据以便展示
                this.list = this.getMockData()
                this.total = this.list.length
            } finally {
                this.loading = false
            }
        },

        // 获取模拟数据
        getMockData() {
            return [
                {
                    id: 1,
                    order_no: 'HT20241110001',
                    amount: 2880,
                    contact_name: '张三',
                    contact_mobile: '13800138000',
                    hotel_name: '北京王府井希尔顿酒店',
                    room_type: '豪华大床房',
                    check_in_date: '2024-11-15',
                    check_out_date: '2024-11-17',
                    order_status: 2,
                    create_time: '2024-11-10 10:00:00',
                    remark: '商务出差'
                },
                {
                    id: 2,
                    order_no: 'HT20241110002',
                    amount: 5680,
                    contact_name: '李四',
                    contact_mobile: '13900139000',
                    hotel_name: '上海外滩华尔道夫酒店',
                    room_type: '江景套房',
                    check_in_date: '2024-11-20',
                    check_out_date: '2024-11-22',
                    order_status: 3,
                    create_time: '2024-11-10 14:30:00'
                }
            ]
        },

        formatStatus(order_status) {
            const statusMap = {
                1: '待付款',
                2: '待确认',
                3: '已确认',
                4: '确认失败',
                5: '已完成',
                6: '取消中',
                7: '取消失败',
                8: '已取消'
            }
            return statusMap[order_status] || '未知'
        },

        getStatusTagType(order_status) {
            const typeMap = {
                1: 'warning',
                2: 'primary',
                3: 'success',
                4: 'danger',
                5: 'success',
                6: 'warning',
                7: 'danger',
                8: 'danger'
            }
            return typeMap[order_status] || 'default'
        },

        handleDetails(row) {
            this.detailData = row
            this.detailDialog = true
        },

        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },

        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
}

.card-header {
    font-weight: 700;
    color: #409EFF;
}

.card-body {
    padding: 12px;
}

.toolbar {
    margin-bottom: 6px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>